import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Sparkles } from 'lucide-react';

const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center px-4 sm:px-6 lg:px-8 bg-slate-900 pt-16">
      {/* Subtle grid pattern */}
      <div className="absolute inset-0 opacity-[0.02]">
        <div className="absolute inset-0" style={{
          backgroundImage: 'linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)',
          backgroundSize: '50px 50px'
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto w-full relative z-10 py-12 md:py-20">
        <div className="grid lg:grid-cols-5 gap-12 items-center">
          {/* Left Content - 3 columns */}
          <div className="lg:col-span-3">
            {/* Label */}
            <div className="mb-8 flex items-center gap-2">
              <Sparkles className="text-teal-400" size={20} />
              <span className="text-teal-400 text-sm font-semibold tracking-wide">
                AI-First Marketing Leader
              </span>
            </div>

            {/* Main Headline */}
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-8 leading-[1.15] text-white">
              I help founders build
              <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-emerald-400">
                AI-powered marketing
              </span>
              <br />
              that scales without the bloat
            </h1>

            {/* Sub-headline */}
            <div className="max-w-2xl mb-12">
              <p className="text-xl text-slate-300 leading-relaxed mb-6">
                Most companies think growth means hiring more people. I show them how to use AI 
                to do more with less—turning small teams into high-output machines.
              </p>
              <p className="text-lg text-slate-400 leading-relaxed">
                12 years building marketing engines across 4 continents. From ₹1000Cr+ traditional 
                budgets to lean AI-first systems that deliver outsized impact.
              </p>
            </div>

            {/* CTAs */}
            <div className="flex flex-wrap gap-4 mb-12">
              <Button
                onClick={() => window.open('https://calendly.com/scalewithanshul/30min', '_blank')}
                size="lg"
                className="bg-teal-500 hover:bg-teal-600 text-white px-8 h-14 text-lg font-semibold shadow-lg shadow-teal-500/20"
              >
                Book Free 15-Min Consultation
                <ArrowRight className="ml-2" size={20} />
              </Button>
              <Button
                onClick={() => scrollToSection('personal')}
                size="lg"
                variant="outline"
                className="border-slate-700 text-slate-300 hover:bg-slate-800 hover:text-white px-8 h-14 text-lg font-medium"
              >
                My Story
              </Button>
            </div>

            {/* Key Stats */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 pt-8 border-t border-slate-800">
              <div>
                <div className="text-2xl font-bold text-white mb-1">12+ years</div>
                <div className="text-sm text-slate-500">Marketing leadership</div>
              </div>
              <div>
                <div className="text-2xl font-bold text-white mb-1">₹1000Cr+</div>
                <div className="text-sm text-slate-500">Budgets managed</div>
              </div>
              <div>
                <div className="text-2xl font-bold text-white mb-1">10+ countries</div>
                <div className="text-sm text-slate-500">Traveled & worked</div>
              </div>
              <div>
                <div className="text-2xl font-bold text-white mb-1">AI-first</div>
                <div className="text-sm text-slate-500">Future-ready</div>
              </div>
            </div>
          </div>

          {/* Right Content - Photo - 2 columns */}
          <div className="lg:col-span-2">
            <div className="relative w-full">
              {/* Decorative gradient orbs */}
              <div className="absolute -top-10 -right-10 w-64 h-64 bg-teal-500/10 rounded-full blur-3xl"></div>
              <div className="absolute -bottom-10 -left-10 w-64 h-64 bg-emerald-500/10 rounded-full blur-3xl"></div>
              
              {/* Photo Container */}
              <div className="relative z-10">
                <div className="rounded-2xl overflow-hidden border-2 border-slate-800 shadow-2xl">
                  <img
                    src="https://customer-assets.emergentagent.com/job_web-profile-19/artifacts/c3qinxhz_57A16EFB-820D-47B2-B23E-55246FD3F4C7.JPG"
                    alt="Anshul Kumar"
                    className="w-full h-auto object-cover aspect-[4/5]"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;